import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function SpeechBubble({ message, loading }) {
    const [shown, setShown] = useState("");

    useEffect(() => {
        if (!message) {
            setShown("");
            return;
        }
        let i = 0;
        setShown("");
        const id = setInterval(() => {
            i += 1;
            setShown(message.slice(0, i));
            if (i >= message.length) clearInterval(id);
        }, 22);
        return () => clearInterval(id);
    }, [message]);

    return (
        <div className="relative w-full max-w-sm" data-testid="speech-bubble">
            <AnimatePresence mode="wait">
                <motion.div
                    key={message}
                    initial={{ opacity: 0, y: 8, scale: 0.96 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -4, scale: 0.96 }}
                    transition={{ type: "spring", stiffness: 220, damping: 22 }}
                    className="relative bg-cream rounded-3xl rounded-bl-sm px-5 py-4 shadow-bubble border border-warm-300/40"
                >
                    <p className="font-body text-warm-900 text-base leading-snug min-h-[1.5em]">
                        {loading ? <Dots /> : shown || <Dots />}
                        {!loading && shown && shown.length < (message?.length ?? 0) && (
                            <motion.span animate={{ opacity: [0, 1, 0] }} transition={{ duration: 0.8, repeat: Infinity }}>|</motion.span>
                        )}
                    </p>
                    {/* tail */}
                    <span
                        className="absolute -bottom-2 left-8 w-4 h-4 bg-cream rotate-45 border-r border-b border-warm-300/40"
                        aria-hidden
                    />
                </motion.div>
            </AnimatePresence>
        </div>
    );
}

function Dots() {
    return (
        <span className="inline-flex gap-1 items-center">
            {[0, 1, 2].map((i) => (
                <motion.span
                    key={i}
                    className="inline-block w-1.5 h-1.5 rounded-full bg-warm-500"
                    animate={{ y: [0, -3, 0], opacity: [0.4, 1, 0.4] }}
                    transition={{ duration: 1, repeat: Infinity, delay: i * 0.15 }}
                />
            ))}
        </span>
    );
}
